import { SITE_URL, business, fullAddress, routes } from "@/lib/site";

const sameAs = Object.values(business.socials);

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": ["MedicalBusiness", "Physician"],
  name: business.clinicName,
  alternateName: "Dr. Satyam Jaiswal Chiropractor",
  url: SITE_URL,
  telephone: business.phoneTel,
  image: `${SITE_URL}/dr-satyam-jaiswal-chiropractor-varanasi.png`,
  medicalSpecialty: "Chiropractic",
  priceRange: "₹₹",
  address: {
    "@type": "PostalAddress",
    streetAddress: `${business.address.line1}, ${business.address.line2}`,
    addressLocality: business.address.area + ", " + business.address.city,
    addressRegion: business.address.state,
    postalCode: business.address.pin,
    addressCountry: "IN",
  },
  areaServed: "Varanasi, Uttar Pradesh",
  sameAs,
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "09:00", closes: "20:00" },
    { "@type": "OpeningHoursSpecification", dayOfWeek: "Sunday", opens: "09:00", closes: "15:00" },
  ],
};

export const physicianSchema = {
  "@context": "https://schema.org",
  "@type": "Physician",
  name: business.doctorName,
  url: `${SITE_URL}${routes.about}`,
  image: `${SITE_URL}/dr-satyam-jaiswal-chiropractor-varanasi.png`,
  medicalSpecialty: "Chiropractic",
  jobTitle: "Chiropractor | Pain & Spine Specialist",
  worksFor: { "@type": "MedicalBusiness", name: business.clinicName },
  address: {
    "@type": "PostalAddress",
    streetAddress: `${business.address.line1}, ${business.address.line2}`,
    addressLocality: business.address.city,
    addressRegion: business.address.state,
    postalCode: business.address.pin,
    addressCountry: "IN",
  },
  sameAs,
};

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: business.clinicName,
  url: SITE_URL,
  logo: `${SITE_URL}/dr-satyam-jaiswal-chiropractor-varanasi.png`,
  sameAs,
  contactPoint: {
    "@type": "ContactPoint",
    telephone: business.phoneTel,
    contactType: "customer service",
    areaServed: "IN",
  },
};

export function faqSchema(faqs) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${SITE_URL}${it.path}`,
    })),
  };
}

export function combine(...schemas) {
  return { "@context": "https://schema.org", "@graph": schemas.map(({ "@context": _c, ...rest }) => rest) };
}

export { fullAddress };
